import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { useClickAway } from 'ahooks';

import { useAppSelector } from 'store/hooks';
import { addressFormat } from 'lib/nicknameFormat';
import MintWalletList from '../Tasks/TaskInfo/MintWalletList';
import { ArrowDownContained01 } from 'lib/lucky-x-icons-2';

const MintWallet = () => {
  const mintListRef = useRef<HTMLDivElement>(null);
  const [showMintList, setShowMintList] = useState(false);
  const {
    raffleInfo: { status, my_entry, type, project, vanity_url },
    mintWallet,
  } = useAppSelector((state) => state.raffleDetails);

  useClickAway(() => {
    setShowMintList(false);
  }, mintListRef);

  const closeShowMintList = useCallback(() => {
    setShowMintList(false);
  }, []);

  const selectRender = useCallback(() => {
    if (
      (status !== 'ENDED' && type === 'WALLET_COLLECTION') ||
      (type !== 'WALLET_COLLECTION' && status !== 'FINALIZED')
    ) {
      return (
        <div
          className={classNames('cursor-pointer text-white', {
            'rotate-180': showMintList,
          })}
          ref={mintListRef}
          onClick={() => {
            setShowMintList(!showMintList);
          }}
        >
          <ArrowDownContained01 size={24} />
        </div>
      );
    }
  }, [showMintList, status, type]);

  return (
    <div className="relative text-base font-normal text-[#FCFCFD]">
      <div className="flex items-center justify-center gap-3">
        <div className="text-base  font-normal text-[#FCFCFD] md:w-auto">
          <div>{addressFormat(mintWallet)}</div>
        </div>
        {selectRender()}
      </div>

      {showMintList && (
        <div className="absolute -left-3 right-0 top-8 z-10 w-[calc(100%+24px)]">
          <MintWalletList
            closeShowMintList={closeShowMintList}
            isRegistered={true}
            vanityUrl={vanity_url}
          />
        </div>
      )}
    </div>
  );
};

export default MintWallet;
